import { Container, Modal } from "react-bootstrap";
import PrimaryButton, {
  SecondaryButton,
} from "../../../../util/Btns/PrimaryButton";
// import PrimaryButton, {
//   SecondaryButton,
// } from "../../../util/Btns/PrimaryButton";

import Close from "../../../../Assets/close.svg";
import styles from "./StoreListingModal.module.scss";
import {
  useUpdateAppstoreGraphics,
  useUploadGraphics,
} from "../../../../hooks/DevAppHooks";
import { useHistory } from "react-router-dom";

const StoreListingModal = ({
  showStoreListingModal,
  setShowStoreListingModal,
  storeListingValues,
  appStoreGraphicsData,
  setBuildSkip,
  setStoreListingUploadBuild,
  match,
  app,
  handleBuildAsWell,
}) => {
  const handleClose = () => setShowStoreListingModal(false);
  const history = useHistory();
  const { mutate: uploadGraphicsMutate } = useUploadGraphics(app.id);
  const { mutate: updateAppstoreGraphics } = useUpdateAppstoreGraphics();

  const handleSubmit = () => {
    uploadGraphicsMutate(storeListingValues);
    if (app?.activeRelease) {
      updateAppstoreGraphics(appStoreGraphicsData);
    }
    history.push(`${match.url}/release-management`);
    handleBuildAsWell();
  };
  const handleSubmitJustStore = () => {
    uploadGraphicsMutate(storeListingValues);
    history.push(`/console/${app.projectId}/${app.id}`);
    if (app?.activeRelease) {
      updateAppstoreGraphics(appStoreGraphicsData);
    }
  };

  return (
    <>
      <Container>
        <Modal
          show={showStoreListingModal}
          onHide={handleClose}
          centered
          contentClassName={styles.content}
          dialogClassName={styles.dialog}
        >
          <Modal.Header className={styles.header}>
            <Modal.Title>
              <div style={{ padding: "0.25em" }}>
                <span
                  style={{ fontFamily: "JioType-Medium", fontSize: "medium" }}
                >
                  Update
                </span>
              </div>
            </Modal.Title>

            <img
              onClick={() => {setShowStoreListingModal(false); setBuildSkip(false)}}
              style={{ marginTop: "15px" }}
              src={Close}
              height="14"
              width="14"
              alt="cross"
              className="cursor-pointer"
            />
          </Modal.Header>

          <Modal.Body>
            <div className={styles.body}>
              <h4>Update only store listing or build as well?</h4>
              <div className={styles.buttonContainer}>
                <SecondaryButton
                  className="secondary-btn-appManage"
                  onClick={() => {
                    handleSubmitJustStore();
                    setShowStoreListingModal(false);
                  }}
                >
                  Just Store listing
                </SecondaryButton>
                <PrimaryButton
                  onClick={() => {
                    handleSubmit();
                    setShowStoreListingModal(false);
                  }}
                >
                  Build as well
                </PrimaryButton>
              </div>
            </div>
          </Modal.Body>
        </Modal>
      </Container>
    </>
  );
};

export default StoreListingModal;
